module.exports = __webpack_public_path__ + "img/rating1_7-7-2021.a7a32a01.jpg";